/**
 * Stable CSS class names for E2E — Customer under-menu paper (horizontal tabs + panels).
 */
export const CUMP = {
    page: 'customer-under-menu-paper',
    tabsHost: 'customer-under-menu-paper__tabs-host',
    panelAccountStatus: 'customer-under-menu-paper__panel-account-status',
    panelScr: 'customer-under-menu-paper__panel-scr',
    panelCommunicationLegacy: 'customer-under-menu-paper__panel-communication-legacy',
    panelCommunicationV2: 'customer-under-menu-paper__panel-communication-v2',
    panelFollows: 'customer-under-menu-paper__panel-follows',
    panelRptHistory: 'customer-under-menu-paper__panel-rpt-history',
    panelLinkedAccounts: 'customer-under-menu-paper__panel-linked-accounts',
    panelAccountHistory: 'customer-under-menu-paper__panel-account-history',
} as const;

export const cumpCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
